<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-form-item
        label="维修类型"
        style="margin-right:15px"
      >
        <el-input
          v-model="repairTypeMap[form.repairType]"
          :disabled="true"
        />
      </el-form-item>

      <el-form-item
        label="车牌号"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.numberPlate"
          :disabled="true"
        />
      </el-form-item>

      <el-form-item
        label="申请内容"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.title"
          type="textarea"
          rows="2"
          :disabled="true"
        />
      </el-form-item>

      <el-form-item
        label="申请详情"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.details"
          type="textarea"
          rows="6"
          :disabled="true"
        />
      </el-form-item>

      <el-form-item
        label="相关图片"
        style="margin-right:15px"
      >
        <template v-for="(url,index) in form.imageUrls">
          <ImgReview :key="'rul'+index" :src="url" error="未上传" style="margin: 0 10px 10px 0;" />
        </template>
      </el-form-item>


      <dev v-if="form.isReportComplete==1">

        <el-form-item
          label="维修费用"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.reportCompleteFee"
            :disabled="true"
          />
        </el-form-item>

        <el-form-item
          label="维修详情"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.reportCompleteDetails"
            type="textarea"
            rows="2"
            :disabled="true"
          />
        </el-form-item>


        <el-form-item
          label="维修图片"
          style="margin-right:15px"
        >
          <template v-for="(url,index) in form.reportCompleteImgs">
            <ImgReview :key="'rull'+index" :src="url" error="未上传" style="margin: 0 10px 10px 0;" />
          </template>
        </el-form-item>

      </dev>

    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgReview from "@/components/ImgReview";


export default {
  name: 'VehicleRepairApplyDetail',
  components: {
    ImgReview,
  },
  data() {
    return {
      repairTypeMap: { '0': '中途坏车', '1': '内部车辆', '2': '外出维修' },
      emptyForm: {},
      form: {
        code: '',
        branchCode: '',
        repairType: '',
        numberPlate: '',
        title: '',
        details: '',
        images: '',
        reviewerRoleCode: '',
        reviewerCode: '',
        status: '',
        step: '',
        reviewerTime: '',
        isOutingRepair: '',
        outingRepairFactory: '',
        outingRepairMan: '',
        outingRepairPhone: '',
        outingRepairDetails: '',
        outingRepairImgs: '',
        isReportComplete: '',
        reportCompleteFee: '',
        reportCompleteDetails: '',
        reportCompleteImgs: ''
      }
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/vehicleRepairApply/${code}`, method: 'get' }).then(response => {
        this.form = response.data
        if (this.form.images) {
          const urlStr = this.form.images
          if (urlStr.indexOf(',') > -1) {
            this.form.imageUrls = urlStr.split(',')
          } else {
            this.form.imageUrls = [urlStr]
          }
        }

        //维修图片
        if (this.form.reportCompleteImgs) {
          const imreportCompleteUrlStr = this.form.reportCompleteImgs
          if (imreportCompleteUrlStr.indexOf(',') > -1) {
            this.form.reportCompleteImgs = imreportCompleteUrlStr.split(',')
          } else {
            this.form.reportCompleteImgs = [imreportCompleteUrlStr]
          }
        }

      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
